export default class BookmarksCrudService {
  getAll(code) {
    return fetch("https://api.tradersr.com/api/bookmarkscrud?uid=" + code)
      .then(res => res.json());
  }
  getBookmarks(userid, rows) {
    return fetch("https://api.tradersr.com/api/bookmarkscrud?uid=" + userid + "&rows=" + rows)
      .then(res => res.json());
  }
}